function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "uploading_svg__a",
  x1: 815.82,
  y1: 804.15,
  x2: 815.82,
  y2: 292.5,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-427.873 -191.154)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M596.787 571.846c-1-3.62-2-7.29-4-10.44a36.28 36.28 0 00-6.56-7.17c-7.25-6.59-16.16-13.28-25.77-11.61a34 34 0 00-8.56 3.12c-1.4.65-2.81 1.3-4.25 1.85a21.2 21.2 0 01-12.83 1.12c-2.2-.59-4.25-1.65-6.42-2.31a20.72 20.72 0 00-3.16-.68 58.18 58.18 0 006.1-3.21c10.79-6.67 19.4-18.67 18.19-31.37-.4-4.3-1.88-8.41-3.34-12.46q-1.92-5.31-3.85-10.63c-1.66-4.61-3.37-9.3-6.41-13.13-3.38-4.26-8.18-7.15-13.14-9.31-10.66-4.63-22.31-6.26-33.81-7.84l-.8-.11v-124.24a8 8 0 00-8-8.05h-15.13l-2-12.23c-1.91-11.61-3.88-23.45-9.23-33.91-3.5-6.85-9.08-13.37-16.59-14.72a16.54 16.54 0 01-4.32-1c-2.2-1.08-3.4-3.48-5.1-5.26-4.36-4.57-11.45-4.64-17.3-7-5.16-2.05-9.38-5.92-14.08-8.89-4.7-2.97-10.55-5.09-15.76-3.15 0 .38-.07.75-.11 1.13l-3.34-1.5c-3.6-1.66-7.28-3.38-10.17-6.12-3.72-3.51-5.7-8.14-7.24-13.08-.16-.52-.31-1-.46-1.55a46.53 46.53 0 0012.44-23.77c.27.87.55 1.75.82 2.63a13.88 13.88 0 001 2.59 6.86 6.86 0 00.47.79 5.1 5.1 0 001.22 1.27 3.41 3.41 0 001.61.63 3 3 0 00.84 0 4.62 4.62 0 003.36-2.87 6 6 0 00.35-1.22 6.31 6.31 0 00.07-.76v-.24-.52-.28-.76c0-.2-.06-.4-.1-.59-.04-.19 0-.11 0-.16-.05-.26-.11-.51-.16-.77a1 1 0 010-.17l-.15-.63-.09-.38v-.1c-.1-.39-.19-.79-.28-1.19a34.44 34.44 0 01-.55-10.57 114.49 114.49 0 012.86-15.36l.21-.91.24-1.06c.16-.72.31-1.44.46-2.16.13-.61.25-1.23.36-1.85.11-.62.19-1.09.27-1.64v-.2a47.52 47.52 0 00.49-11.28c-.47-5.23-2.09-10.18-5.65-14.13-2.51-2.79-5.81-4.85-8.14-7.78-2.19-2.75-3.42-6.13-5.68-8.82-6.25-7.46-22.28-13.21-32.12-14.21-11.27-1.14-29.48 1.74-38.56 8.4-3.36 2.46-5.66 6-8 9.37-4.3 6.26-9.19 12.5-16.08 16-2.61 1.32-5.59 2.32-7.32 4.62a12.59 12.59 0 00-2 5.19 102.21 102.21 0 00-2.06 19.8 24.41 24.41 0 001.1 8.6c.14.38.31.77.49 1.14.16.33.34.66.53 1l.12.21a41.55 41.55 0 013.21 5.45 7.9 7.9 0 01.48 1.66 12.29 12.29 0 01-.28 4.39c0 .22-.08.43-.13.64l-.09.46c0 .14 0 .29-.08.43q-.12.65-.21 1.29c0 .3-.06.61-.07.92a7.51 7.51 0 00.69 3.6 4.58 4.58 0 00.47.76 4 4 0 001.35 1.15 15.14 15.14 0 003.7.88c3.74.84 6.08 3.7 7.6 7.21a25.46 25.46 0 01.89 2.41 42.63 42.63 0 011.4 6.27c1.7-.09 2.69-1.59 3.29-3.23a15.2 15.2 0 00.47-1.65c.23-1.05.46-2.1.7-3.15a46.49 46.49 0 0018.26 20.12c.28.82.55 1.65.8 2.49 1.31 4.53 1.94 9.28-.33 13.24-1.62 2.81-4.35 4.55-7.39 5.75a4.89 4.89 0 00-1.65-1.41c-2.64-1.32-5.8.29-8 2.26-4 3.62-7.26 8.81-12.53 10-1.9.44-4 .35-5.59 1.51a12.92 12.92 0 00-2.59 3.41 11.93 11.93 0 01-10.24 5.1c-1.83-.09-4-.51-5.25.83-.93 1-1 2.59-2 3.54-1.35 1.32-3.54.67-5.42.59a10 10 0 00-7.25 3.14 17.06 17.06 0 00-4.36-10.9c-2.7-2.78-6.45-4.21-9.65-6.39-8-5.44-12-15-16.17-23.76-4.17-8.76-9.67-18-18.77-21.19-2.09-.74-5-.8-5.94 1.23a4.43 4.43 0 00-.15 2.65c.88 4.66 4.2 8.4 7.07 12.15 4.83 6.32 8.88 14.05 7.71 21.95-1.37 9.35-9.7 16.61-10.7 26-.44 4.14.61 8.3.6 12.46 0 2.6-.41 5.23.15 7.76a52.63 52.63 0 002.11 5.65 33.09 33.09 0 011.38 9.31q1.06 19.88 2.11 39.77c.53 9.89-1.63 19.65-3.81 29.38a92.19 92.19 0 00-6.26 18c-2.46 10.83-2.53 22.37 1 32.91 1.89 5.73 4.79 11.1 6.34 16.93 0 .13.06.25.09.37.15 1.24.32 2.48.55 3.71a35.66 35.66 0 001.11 4.2 29.93 29.93 0 002.2 6.87 19.22 19.22 0 006 7c-1.44 2.82-3.77 5.09-5.32 7.85-2.7 4.78-2.81 10.65-1.83 16.07 1.89 10.46 7.54 19.81 15 27.41a8.68 8.68 0 00-1 0 15.68 15.68 0 00-6.84 2.45c-15.79 9.23-24.82 29-21.52 47.1.65 3.54 1.78 7.12 4.14 9.81a15.56 15.56 0 007.29 4.47 25.29 25.29 0 005.37 1c12.31 1 24.23-4.71 36.57-5.19a98.49 98.49 0 0112.25.57q8.91.74 17.86.94c9.69.23 15.15-2.35 21.34-9.6a25.88 25.88 0 003.77-5.94c5.26-.3 11.07-.76 15.28-1.11l.06.59c.23 2 .58 4.3 2.18 5.57a7.79 7.79 0 003 1.22c10.11 2.49 20.34 5 30.74 5a129.72 129.72 0 0014.6-1.13l18.3-2.11a93.21 93.21 0 0115.71 3.42c5.28 1.8 10.22 4.47 15.38 6.57 12 4.87 24.92 6.61 37.71 8.31 2.18.29 4.68.49 6.3-1 2.08-2 1.38-5.35.8-8.15-.24-1.14-.42-2.3-.57-3.46a173.5 173.5 0 0125.26 8.77l1.44.63c.41 2.18 2.43 3.93 4.36 6.28a15.9 15.9 0 002.21 2.73 7.25 7.25 0 003.17 1.15 148.12 148.12 0 0041 1.85 42 42 0 018.45-.29 35.64 35.64 0 016.1 1.38l11.58 3.31c8.53 2.45 17.28 4.92 26.13 4.37a34.71 34.71 0 005.34-.77c7-1.62 13.53-5.54 16.89-11.84 4.51-8.57 2.32-19.1-.25-28.46zm-339.66-156.41a36.39 36.39 0 01-3.34 12.51c-1.24 2.51-2.84 4.82-4 7.34-1.1 2.28-1.92 6.59-2.41 11.32-.6-.1-1.21-.19-1.81-.26.89-3.12 1.56-6.32 2.45-9.45 2.11-7.44 5.58-14.47 9.11-21.46z",
  fill: "url(#uploading_svg__a)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M272.537 569.236c-2.11-4.8-4.11-10.32-2-15.12a12.85 12.85 0 016.65-6.25 32 32 0 019-2.22 125.61 125.61 0 0129.26-.4c.71 5.62-.79 11.32-2.08 16.75-1.17 5-1.84 5.74-7 6-3.34.18-33.04 3.01-33.83 1.24z",
  fill: "#fbbebe"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 361.587,
  cy: 496.856,
  rx: 143,
  ry: 40,
  fill: "#464353"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 361.587,
  cy: 496.856,
  rx: 143,
  ry: 40,
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M387.227 285.696a44.49 44.49 0 01-22.94 20.84 57.58 57.58 0 01-18.16 3.46c-6.79.31-13.72-.13-20.1-2.45-8.56-3.1-15.67-9.44-21-16.83-5.33-7.39-9-15.83-12.19-24.34-1.68-4.43-3.28-9.15-2.49-13.83 5.15-1.17 10.79-2.89 13.45-7.46 2.27-3.92 1.64-8.62.33-13.1-.37-1.27-.8-2.53-1.23-3.74-1-2.9-4.45-8.41-2.05-10.89 1.53-1.57 7.94-2.37 10.15-3.39 6.81-3.14 13.09-7.68 20.57-9.17 6.47-1.29 13.15-.08 19.61 1.26a6.45 6.45 0 012.42.87 5.82 5.82 0 011.8 2.7c1.84 4.48 2.92 9.43 4.4 14.1 1.54 4.89 3.52 9.48 7.23 12.95 2.89 2.71 6.57 4.41 10.17 6.06l8.86 4.06a11.65 11.65 0 014.19 2.71 10.61 10.61 0 012 5.44 50.82 50.82 0 01-5.02 30.75z",
  fill: "#fbbebe"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M359.757 223.726a46 46 0 01-55.63 8.26c-.37-1.27-.8-2.53-1.23-3.74-1-2.9-4.45-8.41-2.05-10.89 1.53-1.57 7.94-2.37 10.15-3.39 6.81-3.14 13.09-7.68 20.57-9.17 6.47-1.29 13.15-.08 19.61 1.26a6.45 6.45 0 012.42.87 5.82 5.82 0 011.8 2.7c1.8 4.48 2.88 9.43 4.36 14.1z",
  opacity: 0.1
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 326.587,
  cy: 189.856,
  r: 46,
  fill: "#fbbebe"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M466.737 339.146l-3.78-22.9c-1.91-11.49-3.88-23.2-9.22-33.55-3.51-6.78-9.08-13.24-16.59-14.58a16.05 16.05 0 01-4.32-1c-2.2-1.06-3.4-3.44-5.09-5.2-4.36-4.52-11.46-4.59-17.3-6.89-5.16-2-9.38-5.85-14.08-8.79-4.7-2.94-10.55-5-15.75-3.12-.84 8.95-1.73 18.1-5.53 26.25a39.28 39.28 0 01-59.26 14.76c-8.91-6.71-14.62-17.06-17.28-27.89-.65-2.64-1.39-5.67-3.82-6.88-2.63-1.32-5.79.28-8 2.22-4.05 3.59-7.27 8.73-12.53 9.94-1.9.44-4 .35-5.58 1.5a12.7 12.7 0 00-2.6 3.37 12 12 0 01-10.23 5.06c-1.83-.09-4-.51-5.25.82-.93 1-1 2.56-2 3.49-1.35 1.31-3.54.67-5.42.6-3.56-.15-6.87 2.13-8.91 5s-3 6.42-4 9.86c10.93 24.34 20.93 48.71 31.86 73.05a6.23 6.23 0 01.79 3 7.31 7.31 0 01-1.36 3c-5.36 8.61-5.19 19.44-4.6 29.56.59 10.12 1.31 20.81-3.21 29.88-1.23 2.49-2.83 4.77-4 7.26-2.74 5.64-3.73 23.68-2.13 29.74h226c-4.31-11.85-2.67-35.63-1.77-48.21.63-8.8-1-17.59-1.7-26.39-1.47-17.97-.37-35.02-3.34-52.96z",
  fill: "#f86d70"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M478.307 459.706c3.33-1.27 7-.81 10.57-.33 11.49 1.57 23.15 3.18 33.8 7.77 5 2.14 9.76 5 13.14 9.21 3 3.79 4.75 8.43 6.41 13l3.84 10.49c1.46 4 2.94 8.08 3.35 12.33 1.2 12.59-7.41 24.46-18.24 31-10.83 6.54-23.58 8.87-36 11.31-12.42 2.44-24.89 5.14-37.26 8a150 150 0 01-17.53 3.45c-13.24 1.5-27.08-.71-39.66 3.67-5 1.75-9.91 4.35-15.1 5.56a93.93 93.93 0 01-10.43 1.68l-23.81 2.72a129.89 129.89 0 01-14.6 1.12c-10.4 0-20.63-2.46-30.73-4.92a7.77 7.77 0 01-3-1.21c-1.6-1.26-1.95-3.49-2.18-5.51q-1.53-13.41-2.68-26.85c-.24-2.91-.42-6.06 1.17-8.51 2-3 5.9-3.94 9.46-4.52a246.88 246.88 0 0145.68-3.17c5.81-5.81 15.39-5.84 23-9a68.39 68.39 0 008.11-4.41 106 106 0 0144.51-14.07 41.45 41.45 0 009.11-1.3c5.89-1.83 11.26-6.81 17.31-5.59.75-2.07 1.27-4.84 3-6.26.86-.73 1.92-1.22 2.71-2 1.67-1.69 1.82-4.35 1.57-6.71-.25-2.36-.81-4.78-.2-7.08a9.79 9.79 0 011.11-2.47c3.01-5.26 7.54-7.9 13.57-7.4z",
  fill: "#464353"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M478.307 459.706c3.33-1.27 7-.81 10.57-.33 11.49 1.57 23.15 3.18 33.8 7.77 5 2.14 9.76 5 13.14 9.21 3 3.79 4.75 8.43 6.41 13l3.84 10.49c1.46 4 2.94 8.08 3.35 12.33 1.2 12.59-7.41 24.46-18.24 31-10.83 6.54-23.58 8.87-36 11.31-12.42 2.44-24.89 5.14-37.26 8a150 150 0 01-17.53 3.45c-13.24 1.5-27.08-.71-39.66 3.67-5 1.75-9.91 4.35-15.1 5.56a93.93 93.93 0 01-10.43 1.68l-23.81 2.72a129.89 129.89 0 01-14.6 1.12c-10.4 0-20.63-2.46-30.73-4.92a7.77 7.77 0 01-3-1.21c-1.6-1.26-1.95-3.49-2.18-5.51q-1.53-13.41-2.68-26.85c-.24-2.91-.42-6.06 1.17-8.51 2-3 5.9-3.94 9.46-4.52a246.88 246.88 0 0145.68-3.17c5.81-5.81 15.39-5.84 23-9a68.39 68.39 0 008.11-4.41 106 106 0 0144.51-14.07 41.45 41.45 0 009.11-1.3c5.89-1.83 11.26-6.81 17.31-5.59.75-2.07 1.27-4.84 3-6.26.86-.73 1.92-1.22 2.71-2 1.67-1.69 1.82-4.35 1.57-6.71-.25-2.36-.81-4.78-.2-7.08a9.79 9.79 0 011.11-2.47c3.01-5.26 7.54-7.9 13.57-7.4z",
  opacity: 0.05
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M281.737 575.416c-6.19 7.17-11.64 9.73-21.33 9.5q-8.94-.21-17.86-.93a100.2 100.2 0 00-12.24-.57c-12.34.48-24.25 6.13-36.56 5.14a25.92 25.92 0 01-5.37-1 15.63 15.63 0 01-7.25-4.41c-2.36-2.67-3.49-6.21-4.14-9.71-3.29-17.94 5.73-37.48 21.52-46.61a15.78 15.78 0 016.84-2.43 16.21 16.21 0 016.92 1.52l.15.06a52.33 52.33 0 0117.14 11.44 9.66 9.66 0 002.62 2.11 9 9 0 003.09.58l13.14.83a31.14 31.14 0 016.6.91 52.46 52.46 0 016.94 3c7.07 3.16 14.91 4 22.55 5.22a3.37 3.37 0 012 .8 3.13 3.13 0 01.62 1.3 25.51 25.51 0 01-5.38 23.25z",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M212.377 525.976a78.9 78.9 0 00-13.15 16.44 82.28 82.28 0 00-10.74 32.54 60.4 60.4 0 00-.11 12.61 15.63 15.63 0 01-7.25-4.42c-2.36-2.67-3.49-6.21-4.14-9.71-3.29-17.94 5.73-37.48 21.52-46.61a15.78 15.78 0 016.84-2.43 16.21 16.21 0 016.92 1.52z",
  opacity: 0.1
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M466.867 550.846c7.35-.2 15.6-.57 21 4.38 5.15 4.68 5.83 12.4 6.17 19.35l.39 8.07c.12 2.46.22 5-.77 7.28-1.76 4-6.59 5.93-11 5.7-4.41-.23-8.46-2.16-12.49-3.9a175.7 175.7 0 00-34-10.71q.57-8.37 1.9-16.66c.61-3.83.71-10.24 3.27-13.42 2.71-3.36 6.24-1.54 9.92-.92a79.63 79.63 0 0015.61.83z",
  fill: "#fbbebe"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M272.647 469.766c0 1-1.57 0-1.71-1.07-1.1-8.09-7.52-14.76-15-18s-16-3.41-24.1-2.64c-12.25 1.16-25.95 5.85-30.48 17.3-1.06 2.68-1.54 5.58-2.84 8.15-1.44 2.82-3.79 5.07-5.35 7.81-2.69 4.74-2.8 10.55-1.83 15.91 2.61 14.3 12.39 26.53 24.24 35 11.85 8.47 25.7 13.53 39.51 18.09a685.19 685.19 0 00112 26.75c6.16.93 12.38 1.79 18.28 3.77 5.28 1.77 10.22 4.42 15.38 6.5 12 4.82 24.91 6.54 37.7 8.23 2.18.28 4.68.48 6.29-1 2.08-1.93 1.39-5.29.8-8.06a43.35 43.35 0 015.09-30.74c2.14-3.6 4.92-7.29 4.52-11.46-.48-4.86-5.32-8.3-10.14-9.08-4.82-.78-9.72.37-14.56 1-1.67.22-3.49.36-5-.49a9.89 9.89 0 01-1.94-1.72 21.93 21.93 0 00-25.54-3.57c-1.79 1-4.5-1.23-6.36-2.07l-21.01-9.53c-24.16-10.93-48.44-21.91-74-28.83a15.54 15.54 0 01-5.7-2.37c-1.27-1-2.18-2.36-3.35-3.47-2.55-2.41-6.1-3.37-9.16-5.08-3.06-1.71-6.46-5.9-5.74-9.33z",
  fill: "#464353"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M596.837 600.456c-3.36 6.23-9.88 10.11-16.88 11.71a33.5 33.5 0 01-5.34.76c-8.85.55-17.59-1.9-26.12-4.32l-11.58-3.28a36.55 36.55 0 00-6.1-1.36 41.86 41.86 0 00-8.44.29 149.59 149.59 0 01-41-1.84 7.23 7.23 0 01-3.17-1.13 15.75 15.75 0 01-2.21-2.71c-3.15-3.79-6.54-6-2.81-11 2.15-2.9 6.14-4.35 7.81-7.68s.6-8.06-.39-11.5c-1.35-4.75-5.79-6.8-7.38-11.16-1.19-3.29.81-7.11 3.82-8.9s6.73-1.93 10.2-1.47c3.47.46 6.87 1.44 10.36 1.71 10.26.82 20.75-4.47 30.6-1.49 2.17.66 4.22 1.71 6.42 2.29a21.35 21.35 0 0012.83-1.11c1.44-.54 2.85-1.19 4.25-1.83a34.23 34.23 0 018.55-3.09c9.61-1.65 18.52 5 25.77 11.49a36.44 36.44 0 016.55 7.1c2 3.12 3.06 6.75 4 10.33 2.65 9.27 4.84 19.69.26 28.19z",
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M596.837 600.456c-3.36 6.23-9.88 10.11-16.88 11.71a32.69 32.69 0 003.55-17.16c-.6-9.51-4.78-18.47-10.11-26.37a93.4 93.4 0 00-11.14-13.57c-3.18-3.2-7.09-5.74-10.51-8.67a34.23 34.23 0 018.55-3.09c9.61-1.65 18.52 5 25.77 11.49a36.44 36.44 0 016.55 7.1c2 3.12 3.06 6.75 4 10.33 2.61 9.31 4.8 19.73.22 28.23z",
  opacity: 0.1
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M294.807 115.196c-3.36 2.43-5.66 5.92-8 9.27-4.31 6.19-9.19 12.37-16.08 15.82-2.61 1.31-5.59 2.3-7.32 4.58a12.34 12.34 0 00-1.95 5.13 101.65 101.65 0 00-2.06 19.6c0 3.28.14 6.66 1.59 9.64 1.37 2.8 3.84 5.17 4.35 8.22.39 2.38-.49 4.75-.8 7.14-.31 2.39.23 5.22 2.44 6.36a14.79 14.79 0 003.7.87c6.65 1.48 8.88 9.28 9.89 15.73 2.26-.13 3.28-2.72 3.75-4.83l6.93-30.81c.75-3.34 2-7.21 5.33-8.38 2.23-.77 4.67-.05 7 .15 9.15.75 16.89-6.32 25.84-8.27a33 33 0 018.71-.57c7.06.35 15.27 3.25 16.77 9.84.25 1.07.4 2.35 1.4 2.88 1 .53 2 .08 3.1 0 4.48-.45 7.12 4.59 8.41 8.71l4.7 15c.7 2.27 1.88 4.94 4.34 5.23 2.27.28 4.2-1.87 4.54-4 .34-2.13-.4-4.34-.89-6.48-2.21-9.85 1.17-19.93 3.23-29.8 2.06-9.87 2.43-21.21-4.48-28.81-2.51-2.75-5.81-4.8-8.15-7.7-2.18-2.72-3.41-6.06-5.67-8.73-6.25-7.37-22.28-13.06-32.11-14-11.19-1.23-29.43 1.62-38.51 8.21z",
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M376.887 199.496c-2.46-.3-3.64-3-4.34-5.23q-2.35-7.51-4.7-15c-1.29-4.13-3.93-9.17-8.41-8.71-1 .11-2.18.52-3.1 0-.92-.52-1.15-1.81-1.4-2.88-1.5-6.6-9.71-9.49-16.77-9.84a33.43 33.43 0 00-8.71.57c-9 2-16.69 9-25.84 8.27-2.36-.19-4.8-.91-7-.14-3.37 1.16-4.58 5-5.33 8.38l-6.93 30.8c-.47 2.12-1.49 4.71-3.75 4.83-1-6.44-3.24-14.24-9.89-15.72a15.72 15.72 0 01-3.7-.87 4.34 4.34 0 01-1.93-2.15c-.18.93-.39 1.86-.51 2.79-.3 2.38.23 5.22 2.44 6.36a14.79 14.79 0 003.7.87c6.65 1.48 8.88 9.28 9.89 15.73 2.26-.13 3.28-2.72 3.75-4.83l6.93-30.81c.75-3.34 2-7.21 5.33-8.38 2.23-.77 4.67-.05 7 .15 9.15.75 16.89-6.32 25.84-8.27a33 33 0 018.67-.57c7.06.35 15.27 3.25 16.77 9.84.25 1.07.4 2.35 1.4 2.88 1 .53 2 .08 3.1 0 4.48-.45 7.12 4.59 8.41 8.71q2.34 7.51 4.7 15c.7 2.27 1.88 4.94 4.34 5.23 2.27.28 4.2-1.87 4.54-4a13.58 13.58 0 00-.6-5.31 4.13 4.13 0 01-3.9 2.3zM265.347 180.456c-.51-3.05-3-5.42-4.35-8.22a16.45 16.45 0 01-1.48-6c0 1.12-.1 2.24-.11 3.37 0 3.28.14 6.66 1.59 9.64 1.11 2.27 2.94 4.27 3.86 6.58a15.06 15.06 0 00.49-5.37zM383.767 159.176c-1.82 8.72-4.66 17.6-3.78 26.34.57-6.45 2.45-12.94 3.78-19.34a51 51 0 001.16-14.82 61.14 61.14 0 01-1.16 7.82z"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M269.287 383.346c-1.21 19.86-15.78 36.27-21.33 55.37-1.38 4.78-2.21 9.74-4.19 14.29-4 9.15-12.23 15.79-21 20.47a31.54 31.54 0 01-10.34 3.76 19.82 19.82 0 01-19.91-10.59c-2.29-4.65-2.61-10-4-15-1.55-5.77-4.45-11.09-6.34-16.76-3.48-10.43-3.41-21.85-1-32.57a100 100 0 0110.73-26.56c.7-1.23 1.41-2.45 2.14-3.66a83.18 83.18 0 016.93-10c6-7.23 13.71-12.79 21.34-18.27a5 5 0 012-1h.12a4.83 4.83 0 012.47.58 195.56 195.56 0 0130.35 16.44c3.44 2.29 8.87 4.85 10.67 8.75 1.8 3.9 1.62 10.51 1.36 14.75z",
  fill: "#fbbebe"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M229.587 291.956a10.35 10.35 0 00-2.22 3.55 167.86 167.86 0 00-14.1 57.62 5.76 5.76 0 01-.65 2.79 12.21 12.21 0 01-1.47 1.59 5.52 5.52 0 00.94 8c1.65-3.11 5.6-4.12 9.11-4.39 16.81-1.33 33.23 6.49 50.09 5.9-1.19-4.11-2.9-8.06-3.87-12.22-4.29-18.47 6.41-38.58-.15-56.37-1.31-3.56-3.5-7.06-6.95-8.62a18.51 18.51 0 00-4.45-1.18c-4.26-.77-12.74-4.06-16.86-2.74-1.52.49-2.12 1.92-3.38 2.78-1.87 1.23-4.41 1.66-6.04 3.29z",
  fill: "#f86d70"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M236.477 457.306a29.49 29.49 0 01-25 14.51 19.7 19.7 0 01-8-1.47c-6.39-2.82-10-9.8-11.34-16.66-1.34-6.86-.92-13.94-1.87-20.87-.76-5.52-2.38-10.88-3.22-16.39-2.06-13.63 2-27.09 4.89-40.66.7-1.23 1.41-2.45 2.14-3.66a83.18 83.18 0 016.93-10c6-7.23 13.71-12.79 21.34-18.27h-8a1.37 1.37 0 012.17.95c.79 7 10.66 14 12.81 20.8 1.33 4.18 2.93 8.28 4 12.54a100.47 100.47 0 011.92 11q2.13 15.53 4.24 31c1.77 12.59 3.29 26.2-3.01 37.18z",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M223.237 326.006l9.65-30.27c1.44-4.53 2.9-9.13 3.07-13.89.17-4.76-1.08-9.75-4.41-13.15-2.7-2.75-6.44-4.17-9.64-6.32-8-5.39-12-14.83-16.17-23.52-4.17-8.69-9.66-17.78-18.76-21-2.1-.74-5-.8-5.94 1.21a4.25 4.25 0 00-.15 2.62c.88 4.62 4.19 8.31 7.07 12 4.83 6.25 8.87 13.9 7.71 21.72-1.38 9.26-9.7 16.44-10.7 25.75-.44 4.1.61 8.21.6 12.34 0 2.56-.42 5.17.15 7.67a51.66 51.66 0 002.11 5.68 33.18 33.18 0 011.38 9.21l2.11 39.36c1.14 21.29-10.41 42-7.23 63 .84 5.51 2.46 10.87 3.22 16.39 1 6.93.53 14 1.87 20.87 1.34 6.87 5 13.84 11.34 16.66a19.7 19.7 0 008 1.47 29.49 29.49 0 0025-14.51c6.3-11 4.78-24.59 3.06-37.13l-4.24-31a100.47 100.47 0 00-1.92-11c-1.06-4.26-2.66-8.36-4-12.54-4.29-13.67-7.5-28.04-3.18-41.62z",
  fill: "#fbbebe"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 265.087,
  y: 328.356,
  width: 223,
  height: 142,
  rx: 7.97,
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 265.087,
  y: 328.356,
  width: 223,
  height: 142,
  rx: 7.97,
  opacity: 0.2
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 376.087,
  cy: 399.356,
  r: 6,
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M112.957 515.696h12.11a25 25 0 0125 25v37.11h-62.11v-37.11a25 25 0 0125-25z",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M112.957 515.696h12.11a25 25 0 0125 25v37.11h-62.11v-37.11a25 25 0 0125-25z",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 524.396,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 518.186,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 511.976,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 505.766,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 499.556,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 493.346,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 487.136,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.987,
  cy: 489.616,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 128.957,
  cy: 487.136,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 133.927,
  cy: 484.646,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 480.916,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 474.706,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 468.496,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.537,
  cy: 462.286,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M137.127 446.256c-1.23.18-2.47.31-3.71.39a28.56 28.56 0 003.2-3.28 21.22 21.22 0 00-3-5.83 10.22 10.22 0 01-4 1.26c-1.23.18-2.47.32-3.71.4a68.41 68.41 0 004.75-5 21.1 21.1 0 106.99 15.65 20.68 20.68 0 00-.32-3.63zM153.737 470.946a9.83 9.83 0 01-4.18 1.4c-1.23.18-2.47.31-3.71.39a36.4 36.4 0 003.68-3.82 12.44 12.44 0 104.21 2z",
  fill: "#00c490"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.077,
  cy: 489.616,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 104.107,
  cy: 487.136,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.137,
  cy: 484.646,
  r: 4.97,
  fill: "#3f3d56"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M79.327 470.946a9.78 9.78 0 004.18 1.4c1.23.18 2.47.31 3.71.39a35.42 35.42 0 01-3.68-3.82 12.44 12.44 0 11-4.21 2z",
  fill: "#00c490"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M112.957 519.426h12.11a25 25 0 0125 25v32.87a4.24 4.24 0 01-4.24 4.24h-53.63a4.24 4.24 0 01-4.24-4.24v-32.87a25 25 0 0125-25z",
  fill: "#3f3d56"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M137.507 447.616a18.83 18.83 0 01-1.6 1.52c.57 0 1.13-.09 1.7-.15-.02-.46-.05-.92-.1-1.37zM128.447 441.676c1.25-.08 2.48-.21 3.72-.39a12 12 0 003.23-.88 21.92 21.92 0 00-1.74-2.87 7.52 7.52 0 01-2 .85 28.79 28.79 0 01-3.21 3.29zM97.897 452.346a21.08 21.08 0 0132.5-17.76l.32-.34a21.1 21.1 0 10-27.82 31.73 21 21 0 01-5-13.63z"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M145.847 475.216c1.24-.08 2.48-.21 3.71-.39a9.7 9.7 0 004.18-1.4 12.43 12.43 0 015 8.8 11.38 11.38 0 00.07-1.31 12.38 12.38 0 00-5-10 9.83 9.83 0 01-4.18 1.4l-1 .12a25.37 25.37 0 01-2.78 2.78zM146.347 470.976a10.19 10.19 0 011.24.09c.65-.69 1.29-1.43 1.94-2.15a12.4 12.4 0 00-15.6 12c0 .42 0 .83.06 1.24a12.42 12.42 0 0112.36-11.18z"
}));

var _ref51 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.217 475.216c-1.24-.08-2.48-.21-3.71-.39a9.65 9.65 0 01-4.18-1.4 12.43 12.43 0 00-5 8.8 11.38 11.38 0 01-.07-1.31 12.38 12.38 0 015-10 9.78 9.78 0 004.18 1.4l1 .12a23.67 23.67 0 002.78 2.78zM86.717 470.976a10.36 10.36 0 00-1.25.09c-.64-.69-1.28-1.43-1.93-2.15a12.4 12.4 0 0115.6 12c0 .42 0 .83-.06 1.24a12.42 12.42 0 00-12.36-11.18z"
}));

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#00c490",
  d: "M4.5 4.5h226v88H4.5z"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 4.5,
  width: 371,
  height: 88,
  rx: 12,
  strokeMiterlimit: 10,
  fill: "none",
  stroke: "#3f3d56",
  strokeWidth: 9
});

function SvgUploading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 599.642 613.004"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
}

export default __webpack_public_path__ + "static/uploading.f67b3443.svg";
export { SvgUploading as ReactComponent };